import logo from './logo.svg';
import { BrowserRouter,Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Categories from "./components/Categories/Categories";
import HomePage from "./components/HomePage/HomePage";
import FooterComponent from "./components/Footer/Footer";
import Myths from "./components/Myths/Myths";
import News from "./components/News/News";
import SignUp from "./components/SignUp/SignUp";
import ArtificialIntelligence from "./components/Ai/Artificial-Intelligence"
import ErrorBoundary from "./components/Error/ErrorBoundary";
import { ressources, sounds} from "./settings";
import {createTheme} from "arwes";
import  {
    ThemeProvider,
    Arwes,
    Puffs,
    Link as Lien,


} from 'arwes';
import {useTranslation} from "react-i18next";
import React from "react";


function App() {

    const {i18n} = useTranslation();
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    }


  return (
      <ThemeProvider  background='' pattern='/static/img/glow.png' theme={createTheme()}>

              <Puffs>
                  <Arwes background={ressources.background.large}>

                      <div>
                          <div className="text-right">
                          <Lien onClick={() => changeLanguage('en')}>en</Lien>
                          <Lien onClick={() => changeLanguage('fr')}> fr</Lien>
                          </div>
                          <Header/>



                              <BrowserRouter>
                                  <ErrorBoundary>
                                  <Routes>

                                      <Route exact path="/"  element={<HomePage/>} />
                                      <Route exact path="*"  element={<ErrorBoundary/>} />
                                      <Route exact path="/category"  element={<Categories/>} />
                                      <Route exact path="/signup"  element={<SignUp/>} />
                                      <Route exact path="/myths" element={<Myths/>}/>
                                      <Route exact path="/news" element={<News/>}/>
                                      <Route exact path="/articifial-intelligence" element={<ArtificialIntelligence/>}/>

                                  </Routes>
                                  </ErrorBoundary>
                              </BrowserRouter>

                          <FooterComponent/>
                      </div>
                  </Arwes>
              </Puffs>
      </ThemeProvider>



  );
}

export default App;
